module.exports = async;


/*****************
 ** WEBPACK FOOTER
 ** external "async"
 ** module id = 845
 ** module chunks = 0
 **/